export default "__VITE_ASSET__B4wmV1Nw__"